import { VFC } from 'react';

import { ListMatch } from 'dashboard/models/list-match';

interface RelatedListMatchesProps {
  listMatches: ListMatch[];
}

const RelatedListMatches: VFC<RelatedListMatchesProps> = () => {
  return <>Lists tab content</>;
};

export default RelatedListMatches;
